import { createFileRoute } from '@tanstack/react-router';

import { TenderPage } from '@/features/subcontracts/tenders-page';

export const Route = createFileRoute('/_app/org/$orgId/tenders/$packageId')({
  component: PageRoute,
});

function PageRoute() {
  const { orgId, packageId } = Route.useParams();
  return <TenderPage orgId={orgId} packageId={packageId} />;
}
